package com.eladfinish.bible.contest.screens.lexicographicalSort.usecases

import com.eladfinish.bible.contest.data.common.downloadBytesAsFile
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.OutputChapters
import com.eladfinish.bible.contest.screens.browse.usecases.GenerateHtmlToPdfUseCase

/**
 * Renders [htmlContent] to a PDF (see GenerateHtmlToPdfUseCaseImpl for why that goes through the
 * server) and hands it to the browser as a download — the web equivalent of saving it to the
 * Documents folder. [onSaved] gets the download's object URL.
 */
class SaveAsPdfUseCaseImpl(
    private val generateHtmlToPdfUseCase: GenerateHtmlToPdfUseCase,
) : SaveAsPdfUseCase {
    override fun invoke(
        hebrewBookName: String,
        outputChapters: OutputChapters,
        chapter: String,
        htmlContent: String,
        onSaved: (filePath: String) -> Unit,
        onError: (Throwable) -> Unit,
    ) {
        generateHtmlToPdfUseCase(
            htmlContent = htmlContent,
            onGenerated = { pdfBytes ->
                try {
                    val fileName = listOf(hebrewBookName, chapter).filter { it.isNotBlank() }.joinToString(" ") + ".pdf"
                    onSaved(downloadBytesAsFile(bytes = pdfBytes, fileName = fileName, mimeType = "application/pdf"))
                } catch (t: Throwable) {
                    onError(t)
                }
            },
            onError = onError,
        )
    }
}

class SavePdfBytesUseCaseImpl : SavePdfBytesUseCase {
    override fun invoke(
        pdfBytes: ByteArray,
        fileName: String,
        onSaved: (uri: String) -> Unit,
        onError: (Throwable) -> Unit,
    ) {
        try {
            val objectUrl = downloadBytesAsFile(bytes = pdfBytes, fileName = fileName, mimeType = "application/pdf")
            onSaved(objectUrl)
        } catch (t: Throwable) {
            onError(t)
        }
    }
}
